import { LogoutAction } from "./actions";

export const removeLocalStorageValue = (key: string): LogoutAction => () => {
    localStorage.removeItem(key);
}